import React from 'react';
import { motion } from 'framer-motion';
import { MessageCircle, Clock, Heart, ShieldCheck, Zap } from 'lucide-react';
const benefits = [{
  icon: ShieldCheck,
  title: 'Bajar la guardia',
  desc: 'Sin activar mecanismos de defensa.'
}, {
  icon: Zap,
  title: 'Activar recuerdo',
  desc: 'Reconectar con la versión de ti que aman.'
}, {
  icon: Heart,
  title: 'Reabrir ternura',
  desc: 'Crear un espacio seguro para el afecto.'
}, {
  icon: MessageCircle,
  title: 'Invitar a presencia',
  desc: 'Sin exigir atención como una deuda.'
}, {
  icon: Clock,
  title: 'En 24 horas',
  desc: 'Resultados rápidos porque cambian el tono emocional.'
}];
export function MechanismSection() {
  return <section className="py-8 px-4 sm:px-6 lg:px-8 bg-[#0a0a0a]" data-id="element-36">
      <div className="max-w-6xl mx-auto" data-id="element-37">
        <div className="grid lg:grid-cols-2 gap-6 items-center" data-id="element-38">
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} data-id="element-39">
            <h2 className="text-2xl md:text-3xl font-serif text-white mb-2 leading-[1.05]" data-id="element-40">
              Mensajes Despertador Emocional (MDE)
            </h2>
            <p className="text-sm text-zinc-400 mb-3 leading-[1.2]" data-id="element-41">
              Los MDE son 5 guiones cortos (copia/pega) diseñados para una sola
              cosa:
              <span className="text-[#d4a574] font-medium" data-id="element-42">
                {' '}
                cambiar el clima en 24 horas{' '}
              </span>
              sin exigir, sin reclamar, sin iniciar una conversación eterna.
            </p>
            <div className="p-3 bg-zinc-900 border-l-4 border-[#d4a574] rounded-r-lg" data-id="element-43">
              <p className="text-zinc-300 italic text-xs leading-[1.3]" data-id="element-44">
                "No son manipulación. No son frases para ligar. Son mensajes con
                intención clara de seguridad emocional."
              </p>
            </div>
          </motion.div>

          <div className="space-y-2" data-id="element-45">
            {benefits.map((benefit, index) => <motion.div key={index} initial={{
            opacity: 0,
            x: 30
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1,
            duration: 0.5
          }} className="flex items-center gap-3 p-2 rounded-lg hover:bg-zinc-900/50 transition-colors group" data-id="element-46">
                <div className="flex-shrink-0 w-9 h-9 rounded-full bg-zinc-900 flex items-center justify-center group-hover:bg-[#d4a574]/10 transition-colors" data-id="element-47">
                  <benefit.icon className="w-4 h-4 text-[#d4a574]" data-id="element-48" />
                </div>
                <div data-id="element-49">
                  <h3 className="text-sm font-medium text-white leading-[1.1]" data-id="element-50">
                    {benefit.title}
                  </h3>
                  <p className="text-zinc-500 text-xs leading-[1.2]" data-id="element-51">
                    {benefit.desc}
                  </p>
                </div>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}